import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { ModulesGrid } from './components/ModulesGrid';
import { IncludesChecklist } from './components/IncludesChecklist';
import { CountdownUrgency } from './components/CountdownUrgency';
import { Pricing } from './components/Pricing';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { initialTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="w-full min-h-screen bg-navy-950 font-sans text-white selection:bg-silver selection:text-navy-950" data-id="element-0" data-mp="23v2rsz5cwt3a">
      <MetaPixel data-id="element-1" data-mp="3ii4ro0w5cqo1" />
      <main data-id="element-2" data-mp="3mlaxx8j9ehui">
        <Hero data-id="element-3" data-mp="3ml17jjuay8oa" />
        <SocialProof data-id="element-4" data-mp="3mkho1yp07c85" />
        <Testimonials testimonials={initialTestimonials} title="💬 LO QUE DICEN LOS QUE YA LO TIENEN" data-id="element-5" data-mp="3mjq1fdddwou0" />
        <ProblemSection data-id="element-6" data-mp="5yj0slx59ec" />
        <ModulesGrid data-id="element-7" data-mp="67z9oh5w26u" />
        <IncludesChecklist data-id="element-8" data-mp="4n5w26l2pak" />
        <CountdownUrgency data-id="element-9" data-mp="82k72sfnuax" />
        <Pricing data-id="element-10" data-mp="2zld0746gb58w" />
        <Testimonials testimonials={moreTestimonials} title="❤️ MÁS RESULTADOS REALES" data-id="element-11" data-mp="2zlv6yuqqp1v2" />
        <GuaranteeSection data-id="element-12" data-mp="33ngf62sbwryx" />
        <FAQ data-id="element-13" data-mp="33ori60dy9voz" />
        <CostComparison data-id="element-14" data-mp="33oi0r16z0wuw" />
        <FinalCTA data-id="element-15" data-mp="38l8j5v6904jh" />
      </main>

      <Footer data-id="element-16" data-mp="38l06a3a4kz8a" />
      <PurchaseNotification data-id="element-17" data-mp="38kgmsi4tu2s5" />
    </div>;
}